export default __webpack_public_path__ + "static/media/icon-csv-active.44e18364.svg";